import Heading from './heading';

export default Heading;
